import React from 'react';
import type {
	EditWidgetRowProps,
	WidgetDataSourceProps
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import { Textarea } from '@upsales/components';
import useTagTranslator from './useTagTranslator';

export const EditUiWidgetPlainText = ({ row, onUpdate }: EditWidgetRowProps) => {
	const text = row.settings?.text || '';

	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				text: e.target.value
			}
		});
	};

	return <Textarea value={text} onChange={handleChange} />;
};

const UiWidgetPlainText: React.FC<WidgetDataSourceProps> = ({ row, dataSources, widgetSettings }) => {
	const translatedText = useTagTranslator(row.settings, dataSources, widgetSettings);

	return (
		<div className="UiWidget__text">
			<span>
				{String(translatedText)
					.split('\n')
					.map((line, idx, arr) => (
						<React.Fragment key={idx}>
							{line}
							{idx < arr.length - 1 && <br />}
						</React.Fragment>
					))}
			</span>
		</div>
	);
};

export default UiWidgetPlainText;
